/**
 * MaintenancePage — shown when the maintenance shield is active.
 * Accessible without authentication. No nav, no chrome, no interactive elements
 * except the support email link.
 *
 * Visual: warm cream background, Inter headline, Inter body,
 * mint accent badge. Mobile-first 320 → 1440, safe-area-inset support.
 */
export default function MaintenancePage() {

  return (
    <div
      style={{
        minHeight: '100dvh',
        backgroundColor: '#FAF6F1',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding:
          'max(env(safe-area-inset-top, 0px), 2rem) max(env(safe-area-inset-right, 0px), 1.5rem) max(env(safe-area-inset-bottom, 0px), 2rem) max(env(safe-area-inset-left, 0px), 1.5rem)',
        fontFamily: 'Inter, system-ui, sans-serif',
        color: '#1A1A1A',
      }}
    >
      <div
        style={{
          maxWidth: '32rem',
          width: '100%',
          textAlign: 'center',
        }}
      >
        {/* Mint badge */}
        <span
          role="status"
          style={{
            display: 'inline-block',
            backgroundColor: '#8DD9BF',
            color: '#0F2B21',
            fontFamily: 'Inter, system-ui, sans-serif',
            fontSize: '0.75rem',
            fontWeight: 600,
            letterSpacing: '0.04em',
            textTransform: 'uppercase',
            padding: '4px 12px',
            borderRadius: '999px',
            marginBottom: '24px',
          }}
        >
          Vedligeholdelse i gang
        </span>

        {/* Headline — Inter, fluid 32 → 64px */}
        <h1
          style={{
            fontFamily: 'Inter, system-ui, sans-serif',
            fontSize: 'clamp(2rem, 5vw + 1rem, 4rem)',
            fontWeight: 400,
            lineHeight: 1.15,
            color: '#1A1A1A',
            margin: '0 0 24px',
          }}
        >
          Vi opdaterer Tryg&nbsp;Hånd
        </h1>

        {/* Body 1 */}
        <p
          style={{
            fontFamily: 'Inter, system-ui, sans-serif',
            fontSize: 'clamp(1rem, 1vw + 0.875rem, 1.125rem)',
            lineHeight: 1.6,
            color: '#4A4A4A',
            margin: '0 0 16px',
          }}
        >
          Platformen er midlertidigt utilgængelig mens vi forbedrer den. Vi er
          tilbage om kort tid.
        </p>

        {/* Body 2 — with email link */}
        <p
          style={{
            fontFamily: 'Inter, system-ui, sans-serif',
            fontSize: 'clamp(1rem, 1vw + 0.875rem, 1.125rem)',
            lineHeight: 1.6,
            color: '#4A4A4A',
            margin: '0 0 40px',
          }}
        >
          Har du et akut spørgsmål om en igangværende vagt eller udbetaling,
          skriv til{' '}
          <a
            href="mailto:support@tryghaand.dk"
            style={{
              color: '#0F6B4F',
              textDecoration: 'underline',
              textUnderlineOffset: '2px',
            }}
          >
            support@tryghaand.dk
          </a>
          .
        </p>

        {/* Footer */}
        <p
          style={{
            fontFamily: 'Inter, system-ui, sans-serif',
            fontSize: '0.75rem',
            color: '#9A9A9A',
            margin: 0,
          }}
        >
          Tryg&nbsp;Hånd &middot; vedligeholdelse&nbsp;pågår
        </p>

      </div>
    </div>
  );
}
